export class ListApiError extends Error {
  public status: number;

  constructor(status: number, message?: string) {
    super(message);
    this.name = 'ListApiError';
    this.status = status;
  }
}

export type CreateListErrorType = 'network' | 'limit';

export const isListLimitError = (error: unknown): boolean =>
  error instanceof ListApiError && error.status === 403;

export const classifyCreateListError = (error: unknown): CreateListErrorType =>
  isListLimitError(error) ? 'limit' : 'network';
